import CreditCard from './CreditCard.vue';

export { CreditCard };
export default CreditCard;
